import { render, staticRenderFns } from "./AccessTagSettings.vue?vue&type=template&id=11d989c3&"
import script from "./AccessTagSettings.vue?vue&type=script&lang=js&"
export * from "./AccessTagSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports